import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// import { getDetailsBlockchainHistory, getHistoryRecords } from '../services/sql/sqlHelpers';
import { appContext } from '../AppContext';
import { addNotValidated } from '../utils/history/addNotValidated';
import LoadingDots from '../components/Animations/LoadingDots';
import { ReportPage } from '../components/Details/ReportPage';
import { DetailsHeaderInternal } from '../components/Details/DetailsHeaderInteral';
import GradientBackground from '../components/GradientBackground/GradientBackground';
import { blockchainService } from '../services/blockchainService';
import { historyService } from '../services/historyService';

const Details = () => {
  const { setFiles, validationComplete, setValidationComplete, validateState } =
    useContext(appContext);
  const [reportData, setReportData] = useState<HistoryDetails | null>(null); // Store the filtered item TODO fix type
  const [blockHistory, setBlockHistory] = useState<any | null>(null); // Store the filtered item TODO fix type

  const { id } = useParams();
  const navigate = useNavigate();

  // // Update with history data from SQL
  // const getHistory = async (): Promise<void> => {
  //   const response = await axios.get(API.HISTORY.getAll, {
  //     withCredentials: true,
  //   });
  //   const result = response.data.data.find((item) => item.HASH === id);
  //   setReportData(result);
  // };

  //Filter out history data for specific file.
  const getDetails = async () => {
    if (id) {
      try {
        const res = await historyService.getById(id);

        if (res.data.REQ_ID) {
          const blockchainRes = await blockchainService.getByReqId(res.data.REQ_ID);
          setBlockHistory(blockchainRes.data);
        } else {
          console.log('No REQ_ID found in history data');
        }

        setReportData(res.data);
      } catch (error) {
        console.error('Error in getDetails:', error);
      }
    }
  };

  useEffect(() => {
    // getHistory();
    getDetails();
  }, [id]);

  // Function to add an uploaded file to the DragNDrop box.
  const handleNotValidated = async (hash) => {
    await addNotValidated(hash, setFiles, validationComplete, validateState, setValidationComplete);

    navigate('/');
  };

  return (
    // TODO_ if no id, show error page
    <>
      <main className="relative flex flex-col justify-center p-0 min-h-screen">
        <GradientBackground />
        <DetailsHeaderInternal />
        <div className="relative bg-black flex-1">
          {reportData ? (
            <ReportPage
              reportData={reportData}
              blockHistory={blockHistory}
              handleNotValidated={handleNotValidated}
            />
          ) : (
            <div className="flex flex-col items-center justify-center gap-2 min-h-[50vh] p-4">
              <div className="h-[60px] w-[60px] sm:h-[80px] sm:w-[80px]">
                <LoadingDots spinningRadius={20} heightWidthPx={'64px'} />
              </div>
              <p className="text-lg sm:text-xl font-normal text-core-grey-5 text-center">
                Loading...
              </p>
            </div>
          )}
        </div>
      </main>
    </>
  );
};

export default Details;

// OLD ISH
// const Details = () => {
//   const { setFiles, validationComplete, setValidationComplete, validateState } =
//     useContext(appContext);
//   const [reportData, setReportData] = useState<HistoryDetails | null>(null); // Store the filtered item TODO fix type
//   const [blockchainHistory, setBlockchainHistory] = useState<any | null>(null); // Store the filtered item

//   const { id } = useParams();
//   const navigate = useNavigate();

//   // // Update with history data from SQL
//   // const getHistory = async (): Promise<void> => {
//   //   const response = await axios.get(API.HISTORY.getAll, {
//   //     withCredentials: true,
//   //   });
//   //   const result = response.data.data.find((item) => item.HASH === id);
//   //   setReportData(result);
//   // };

//   //Filter out history data for specific file.
//   const getDetails = async () => {
//     if (id) {
//       const detailsBlockchainHistory = await axios.get(API.HISTORY.getById(id), {
//         withCredentials: true,
//       });
//       setReportData(detailsBlockchainHistory.data.data);
//     }
//   };

//   useEffect(() => {
//     // getHistory();
//     getDetails();
//   }, [id]);

//   // Function to add an uploaded file to the DragNDrop box.
//   const handleNotValidated = async (hash) => {
//     await addNotValidated(hash, setFiles, validationComplete, validateState, setValidationComplete);

//     navigate('/');
//   };

//   return (
//     // TODO_ if no id, show error page
//     <>
//       <main className="relative flex flex-col justify-center p-0">
//         <GradientBackground />
//         <DetailsHeaderInternal />
//         <div className="relative bg-black">
//           {reportData ? (
//             <ReportPage
//               reportData={reportData}
//               blockchainHistory={blockchainHistory}
//               handleNotValidated={handleNotValidated}
//             />
//           ) : (
//             <div className="flex flex-col items-center justify-center gap-2">
//               <div className="h-[80px] w-[80px]">
//                 <LoadingDots spinningRadius={20} heightWidthPx={'64px'} />
//               </div>
//               <p className="text-xl font-normal text-core-grey-5">Loading...</p>
//             </div>
//           )}
//         </div>
//       </main>
//     </>
//   );
// };

// export default Details;
